import { render, staticRenderFns } from "./ListHorario.vue?vue&type=template&id=0036de7b&"
import script from "./ListHorario.vue?vue&type=script&lang=js&"
export * from "./ListHorario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports